var root = require('./_root');

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;



//////////////////
// WEBPACK FOOTER
// ./~/react-css-modules/~/lodash/_coreJsData.js
// module id = 5854
// module chunks = 1